import l from "clsx";
const o = "gap-x-300 gap-y-100", e = "gap-200 sm:gap-300", r = "gap-100", p = {
  /** Width 96px */
  xs: "w-1200",
  /** Width 128px */
  sm: "w-[128px]",
  /** Width 176px */
  md: "w-[176px]",
  /** Width 224px */
  lg: "w-[224px]",
  /** Width 288px */
  xl: "w-[288px]"
}, a = {
  /** Max width 384px */
  sm: "max-w-sm",
  /** Max width 576px */
  md: "max-w-xl",
  /** Max width 768px */
  lg: "max-w-3xl"
}, x = "grid grid-cols-2", i = "grid grid-cols-1 sm:grid-cols-2", s = "[&>:where(:not([class*=w-]))]:grow", g = {
  /** Form layout tokens */
  tokens: {
    /** Allow fields to grow inside the container */
    allowFieldGrow: s,
    /** Gap between form fields */
    fieldGap: e,
    /** Gap between fields that are grouped */
    fieldGroupGap: r,
    /** Width presets for form fields */
    fieldWidth: p,
    /** Gap between form toggles */
    toggleGap: o,
    /** Max width for form fields */
    maxWidth: a,
    /** Base grid for form fields */
    baseGrid: x,
    /** Responsive grid for form fields */
    responsiveGrid: i
  },
  /** For form toggle components: Checkbox, Radio */
  toggles: {
    /** Display toggles vertically */
    vertical: l("flex flex-col", o),
    /** Display toggles horizontally */
    horizontal: l("flex", o),
    /** Display toggles on 2 columns */
    grid: l(x, o),
    /** Wrap toggles */
    wrap: l("flex flex-wrap", o),
    /** On mobile, display toggles in a column, then, at breakpoint `sm`, display on 2 columns */
    responsive: l(i, o)
  },
  /** For form field components: Input, Select, Textarea */
  fields: {
    /** Display fields vertically */
    vertical: l("flex flex-col", e),
    /** Display fields horizontally */
    horizontal: l("flex", s, e),
    /** Display fields on 2 columns */
    grid: l(x, e),
    /** Wrap fields */
    wrap: l("flex flex-wrap", s, e),
    /** On mobile, display fields in a column, then, at breakpoint `sm`, display in 2 columns */
    responsive: l(i, e),
    /** Join fields horizontally */
    group: l("flex", s, r),
    /** On mobile, join fields vertically, then, at breakpoint `sm`, join horizontally */
    groupResponsive: l("flex flex-col sm:flex-row", r)
  }
};
export {
  g as formLayout
};
